export default `
  query fetchGitHubRepoFileContent($login: String!, $owner: String!, $repo: String!, $branch: String, $files: [RepoFileInput!]) {
    fetchGitHubRepoFileContent(login: $login, owner: $owner, repo: $repo, branch: $branch, files: $files) {
      success
      errorText
      resData {
        path
        name
        type
        content
      }
    }
  }
`
